<template>
  <div class="message-page-view">
    <div class="search-view">
      <div class="search-item-view">
        <div class="search-title">
          搜索消息:
        </div>
        <div class="search-item">
          <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="请输入内容"
              v-model="searchData.searchText">
          </el-input>
        </div>
        <div class="search-button">
          <el-button @click="handleSearch"
                     type="primary"
                     icon="el-icon-search"
                     size="medium">
            搜索
          </el-button>
        </div>
      </div>
    </div>
    <div class="sketch-view">
      <div class="sketch-item-view" v-if="loginStatus">
        <div class="sketch-item">
          当前登录用户:{{platformUserData.userName}}
        </div>
      </div>
      <div class="sketch-item-view">
        <div class="sketch-item">
          <!--用户注册-->
          <el-button type="primary" size="mini" @click="showReg">
            用户注册
          </el-button>
        </div>
      </div>
      <div class="sketch-item-view" v-if="!loginStatus">
        <div class="sketch-item">
          <!--用户登录-->
          <el-button type="primary" size="mini" @click="showLogin">
            用户登录
          </el-button>
        </div>
      </div>
      <div class="sketch-item-view" v-else>
        <div class="sketch-item">
          <!--用户登录-->
          <el-button type="primary" size="mini" @click="logOut">
            退出登录
          </el-button>
        </div>
      </div>
    </div>
    <div class="video-view">
      <div class="video-item-view" v-for="(item,index) in dataList" :key="index">
        <el-divider content-position="center" v-if="false">信息</el-divider>
        <div class="message-view">
          <el-collapse>
            <el-collapse-item :title="'用户'+item.sourceUserName + '发送的消息'">
              <div class="message-text">消息内容: {{item.transmitText}}</div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="publisher-view">
          视频发布人: {{item.videoPublisherName}}
        </div>
        <div class="video-head">
          视频标题: {{item.videoText}}
        </div>
        <div class="video-item">
          <vueMiniPlayer ref="vueMiniPlayer"
                         :video="item.videoItem" :mutex="true"
                         @fullscreen="handleFullscreen" />
        </div>
        <div class="video-bottom">
          <div class="bottom-show-view">
            <div class="bottom-show-item">
              <el-tag type="primary">平均评分:{{item.starNum}}</el-tag>
            </div>
            <div class="bottom-show-item">
              <el-tag type="primary">评论数量:{{item.commentNum}}</el-tag>
            </div>
          </div>
          <div class="bottom-handle-view">
            <div class="bottom-handle-item">
              <el-badge :value="item.tagNum" class="item">
                <el-button size="mini" @click="videoTag(item)">点赞</el-button>
              </el-badge>
            </div>
            <div class="bottom-handle-item">
              <el-button size="mini" @click="downloadVideo(item)">下载视频</el-button>
            </div>
            <div class="bottom-handle-item">
              <el-button size="mini" @click="showCommentView(item)">评论视频</el-button>
            </div>
            <div class="bottom-handle-item">
              <el-button size="mini" @click="showCommentDrawer(item)">查看评论</el-button>
            </div>
            <div class="bottom-handle-item">
              <el-button size="mini" @click="showVideoTransmit(item)">转发视频</el-button>
            </div>
            <div class="bottom-handle-item">
              <el-button size="mini" @click="deleteVideoTransmit(item)">删除消息</el-button>
            </div>
          </div>
        </div>
      </div>
      <el-drawer
          title="视频评论内容"
          :visible.sync="commentDrawerShow"
          :direction="commentDrawerDirection"
          :before-close="handleDrawerClose">
        <div class="comment-view">
          <el-collapse @change="handleCommentCollapseChange">
            <el-collapse-item v-for="(item,index) in commentList" :key="index"
                              :title="'用户'+item.platformUserName+'在'+item.createTime+'的评论'">
              <div class="star-view">视频评分: {{item.starNum}}</div>
              <div class="comment-text-view">{{item.commentText}}</div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-drawer>
      <!--视频评论-->
      <CommentView ref="commentView" @handleSuccess="commentSuccess"></CommentView>
      <!--用户登录-->
      <VideoTransmitView ref="videoTransmitView"
                         @handleSuccess="transmitVideoSuccess">
      </VideoTransmitView>
    </div>
    <div class="pagination-view">
      <div class="pagination-item-view">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :background="true"
            :current-page="paginationData.currentPage"
            :page-sizes="[5, 10, 60, 80, 100, 200, 300]"
            :page-size="paginationData.itemsPerPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationData.totalCount">
        </el-pagination>
      </div>
    </div>
    <!--用户注册-->
    <RegisterView ref="registerView"
                  @handleSuccess="regSuccess">
    </RegisterView>
    <!--用户登录-->
    <LoginView ref="loginView"
                  @handleSuccess="loginSuccess">
    </LoginView>
  </div>
</template>

<script>
import RegisterView from './RegisterView'
import LoginView from './LoginView'
import PlatformApi from "@/services/platform-user";
import CommentView from "./CommentView";
import VideoTransmitView from "./VideoTransmitView";
export default {
  name: "TransmitList",
  components:{
    RegisterView:RegisterView,
    LoginView:LoginView,
    CommentView:CommentView,
    VideoTransmitView:VideoTransmitView,
  },
  props: {
    /*topList:{
      type: Array,
      required: true,
      default: () => []
    }*/
  },
  data() {
    return {
      //视频评论内容
      commentList:[],
      //视频评论是否展示
      commentDrawerShow: false,
      //视频评论弹出方向
      commentDrawerDirection: 'rtl',
      searchData:{
        searchText:'',
        querySelf:false,
      },
      paginationData: {
        itemsPerPage: 10,
        totalCount: 0,
        currentPage:1
      },
      dataList:[],
      //------------用户登录相关 start----------------
      platformUserData:{},
      loginStatus:false,
      //------------用户登录相关 end----------------
    };
  },
  computed:{
    platformToken(){
      return this.$store.state.platformToken
    }
  },
  methods:{
    //删除视频
    deleteVideoTransmit(item){
      console.log('删除消息:'+JSON.stringify(item))
      const loading = this.$loading({
        lock: true,
        text: "正在操作",
      });
      let videoTransmitId = item.videoTransmitId
      try {
        PlatformApi.deleteVideoTransmit({
          videoTransmitId:videoTransmitId
        }).then((res) => {
          console.log('删除消息结果:'+JSON.stringify(res))
          if (res.success) {
            this.$message({
              message: "删除消息成功!",
              type: "success",
            });
            //传递到父组件 刷新界面
            this.$emit('resetCurrentPage',{})
          } else {
            this.$message.error('服务器异常');
          }
        });
        loading.close();
      } catch (error) {
        loading.close();
        this.$message.error(error.message || error.msg || "服务器异常");
      }
    },
    //视频点赞
    videoTag(item){
      const loading = this.$loading({
        lock: true,
        text: "正在操作",
      });
      let videoDataId = item.videoDataId
      try {
        PlatformApi.videoTag({
          videoDataId:videoDataId
        }).then((res) => {
          console.log('点赞结果:'+JSON.stringify(res))
          if (res.success) {
            this.$message({
              message: "视频点赞成功!",
              type: "success",
            });
            this.queryCurrentTransmit();
          } else {
            this.$message.error('服务器异常');
          }
        });
        loading.close();
      } catch (error) {
        loading.close();
        this.$message.error(error.message || error.msg || "服务器异常");
      }
    },
    //查询视频评论
    async queryComment(videoDataId){
      const loading = this.$loading({
        lock: true,
        text: "正在查询评论",
      });
      try {
        PlatformApi.queryComment({
          videoDataId:videoDataId
        }).then((res) => {
          console.log('查询视频评论结果:'+JSON.stringify(res))
          if (res.success) {
            let data = res.data
            if(data && data.length > 0){
              this.commentList = data;
            }
          } else {
            this.$message.error('服务器异常');
          }
        });
        loading.close();
      } catch (error) {
        loading.close();
        this.$message.error(error.message || error.msg || "服务器异常");
      }
    },
    //处理视频评论内容展开
    handleCommentCollapseChange(val){
      console.log('handleCommentCollapseChange:'+val)
    },
    //评论成功
    commentSuccess(){
      this.$emit('commentSuccess')
      console.log('评论成功')
    },
    //弹出视频转发
    showVideoTransmit(item){
      console.log('showVideoTransmit:'+JSON.stringify(item))
      this.$refs.videoTransmitView.showTransmit(item)
    },
    //视频转发
    transmitVideoSuccess(){
      console.log('视频转发成功')
    },
    //下载视频
    downloadVideo(item){
      //window.location.href = this.videoItem.url
      window.open(item.videoItem.url)
    },
    //弹出视频评论
    showCommentView(item){
      console.log('showCommentView')
      this.$refs.commentView.showAdd(item);
    },
    //查看评论视频
    async showCommentDrawer(item){
      console.log('showCommentDrawer')
      await this.queryComment(item.videoDataId);
      this.commentDrawerShow = true
    },
    handleDrawerClose(){
      console.log('handleDrawerClose')
      this.commentDrawerShow = false
    },
    handleFullscreen(){},
    //重置当前界面
    resetCurrentPage(item){
      //传递到父组件 刷新界面
      this.$emit('resetCurrentPage',item)
    },
    //处理登录成功
    async loginSuccess(data){
      console.log('登录成功123:'+JSON.stringify(data))
      if(data){
        this.loginStatus = true;
        this.platformUserData = data;
      }
    },
    async regSuccess(){
      console.log('注册成功')
      await this.init();
    },
    //退出登录
    logOut() {
      this.$store.dispatch("PlatformUserLogOut").then(() => {
        localStorage.clear();
        this.$router.push(this.$commonConstants.PLATFORM_MAIN_PAGE);
        this.$message.warning("退出登录成功，等待页面刷新");
        this.loginStatus = false;
        location.reload();
      });
    },
    showLogin(){
      this.$refs.loginView.showLogin({});
    },
    showReg(){
      this.$refs.registerView.showReg({});
    },
    // 搜索事件
    handleSearch() {
      this.queryCurrentTransmit();
    },
    //处理登录验证
    async handleLoginVerify(){
      //根据Token判断是否登录
      let platformToken = localStorage.getItem(this.$commonConstants.PLATFORM_TOKEN) || '';
      let platformUserData = JSON.parse(localStorage.getItem(this.$commonConstants.PLATFORM_USER_DATA));
      if(platformToken){
        this.loginStatus = true;
      }else{
        this.loginStatus = false;
      }
      if(platformUserData){
        this.platformUserData = platformUserData;
      }
    },
    // 初始化数据
    async init() {
      await this.handleLoginVerify();
      await this.queryCurrentTransmit();
    },
    //分页查询集合
    queryCurrentTransmit() {
      const loading = this.$loading({
        lock: true,
        text: "正在请求。。。",
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      });
      //处理登录验证
      this.handleLoginVerify();
      let platformToken = localStorage.getItem(this.$commonConstants.PLATFORM_TOKEN) || '';
      console.log('platformToken:'+platformToken)
      if(!platformToken){
        console.log('需要登录:'+platformToken)
        this.$message.warning("请登录");
        this.dataList = new Array();
        loading.close();
        return;
      }
      let params = {
        ...this.searchData,
        itemsPerPage: this.paginationData.itemsPerPage,
        currentPage: this.paginationData.currentPage,
      }
      PlatformApi.queryCurrentTransmit({
        ...params
      }).then((res) => {
        //console.log('res:'+JSON.stringify(res))
        let data = res.data
        //console.log('data:'+JSON.stringify(data))
        if (!res.success) {
          //this.$message.warning(res.message || res.msg || "服务器异常");
          this.dataList = new Array();
          loading.close();
          return;
        }
        if(!data){
          this.dataList = new Array();
          loading.close();
          return;
        }
        this.paginationData.totalCount = data.totalCount
        this.paginationData.itemsPerPage = data.itemsPerPage
        this.paginationData.currentPage = data.currentPage
        data = data.data
        if(data.length > 0){
          data.map((item) => {
            let videoItem = {
              url: this.handleFileUrl(item.videoUrl),
              cover: this.handleImageUrl(item.faceUrl),
              muted: false,
              loop: false,
              preload: 'auto',
              poster: '',
              volume: 1,
              autoplay: false
            }
            item.videoItem = videoItem;
          })
        }
        this.dataList = data;
        loading.close();
      }).catch((error) => {
        console.log(error);
        this.$message.warning(error.message || error.msg || "服务器异常");
        loading.close();
      });
    },
    handleSizeChange(val){
      console.log(`每页 ${val} 条`);
      this.paginationData.itemsPerPage = val
      this.queryCurrentTransmit();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.paginationData.currentPage = val
      this.queryCurrentTransmit();
    },
  },
  created() {
    //this.init();
  },
}
</script>

<style lang="scss" scoped>
.message-page-view {
  //height: 100Vh;
  //position: relative;
  //border: 2px solid #ef1313;
  .search-view{
    width: 100%;
    margin: 10px 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .search-item-view{
      margin: 10px 10px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 70%;
      .search-title{
        margin: 10px 5px;
        font-size: 20px;
        font-weight: bold;
      }
      .search-item{
        width: 60%;
        margin: 10px 5px;
        border-radius: 3px;
      }
      .search-button{
        margin: 10px 5px;
      }
    }
  }
  .sketch-view{
    width: 100%;
    margin: 0px 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    //border: 1px solid #e10e0e;
    .sketch-item-view{
      margin: 10px 10px;
      .sketch-item{

      }
    }
  }
  .video-view{
    width: 100%;
    margin: 10px 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .video-item-view{
      width: 40%;
      margin: 10px 10px;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      background-color: #dadee1;
      top:-100px;
      .publisher-view{
        margin: 10px 10px;
        font-weight: bold;
        font-size: 20px;
      }
      .video-head{
        margin: 5px 10px;
        font-weight: bold;
        font-size: 15px;
        color: #409EFF;
      }
      .message-view{
        margin: 5px 0px;
        font-weight: bold;
        width: 100%;
        //border: 1px solid #d00d3a;
        .message-text{
          font-size: 15px;
        }
      }
      .video-item{

      }
      .video-bottom{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .bottom-show-view{
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-start;
          .bottom-show-item{
            margin: 10px 10px;
          }
        }
        .bottom-handle-view{
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-start;
          .bottom-handle-item{
            margin: 10px 10px;
          }
        }
      }
    }
    .comment-view{
      margin: 10px 10px;
      .star-view{
        color: #537be0;
        font-size: 15px;
        font-weight: bold;
      }
      .comment-text-view{
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
  .pagination-view{
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position:fixed;
    bottom:0;
    background-color: #edeff1;
    .pagination-item-view{
      //background-color: #edeff1;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// TransmitList.vue?215abc3e